export default __webpack_public_path__ + "static/media/WhatsApp Image 2024-04-17 at 17.11.36_fa42a835.b05d0574.jpg";